const SvgAnalytics1 = (props) => (
  <>
    <circle cx={96} cy={96} r={96} fill={props.p20} />
    <path d="M0 96C0 42.98 42.98 0 96 0c0 0-.09 47.87-.13 95.81" fill={props.p10} />
    <path d="M28.12 163.77C10.75 146.4 0 122.4 0 95.89c0 0 47.87.09 95.81.13l-67.69 67.75Z" fill={props.p30} />
  </>
);

export default SvgAnalytics1;
